import layout from '@/layout'

export default {
  path: '/tenant',
  component: layout,
  redirect: '/tenant/manage',
  name: 'tenantInfo',
  meta: {
    title: '租户管理',
    icon: 'hospital'
  },
  children: [
    {
      path: '/tenant/manage',
      component: () => import('@/views/tenantManage/tenant-manager'),
      meta: {
        title: '租户信息',
        icon: 'hospital-two'
      }
    },
    {
      path: '/tenant/manage/:tenantId',
      component: () => import('@/views/tenantManage/subTenant-manager'),
      meta: { title: '子诊所管理' }
    },
    {
      path: '/tenant/user/:tenantId',
      component: () => import('@/views/tenantManage/tenant-manager/tenant-user'),
      meta: { title: '租户用户' }
    },
    {
      path: '/clinic/user/:clinicId',
      component: () => import('@/views/tenantManage/subTenant-manager/clinic-user'),
      meta: { title: '诊所用户' }
    }
  ]
}
